var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdventurePreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0206 7.7413L14.0196 7.74582C14.0239 7.72054 14.0259 7.71681 14.0206 7.7413ZM13.7457 7.46002C13.834 7.67335 13.9 7.85694 13.9464 8C13.9 8.14306 13.834 8.32665 13.7457 8.53998C13.5135 9.10121 13.1514 9.81056 12.6429 10.497C11.6317 11.8621 10.1651 13 8 13C5.83488 13 4.36829 11.8621 3.35711 10.497C2.84861 9.81056 2.48652 9.10121 2.25428 8.53998C2.16601 8.32665 2.09995 8.14306 2.05359 8C2.09995 7.85694 2.16601 7.67335 2.25428 7.46002C2.48652 6.89879 2.84861 6.18944 3.35711 5.50295C4.36829 4.13787 5.83488 3 8 3C10.1651 3 11.6317 4.13787 12.6429 5.50295C13.1514 6.18944 13.5135 6.89879 13.7457 7.46002ZM1.97939 7.7413C1.97413 7.71681 1.97606 7.72054 1.98039 7.74582L1.97939 7.7413ZM1.97939 8.2587L1.98039 8.25418C1.97606 8.27946 1.97413 8.28319 1.97939 8.2587ZM14.0196 8.25418L14.0206 8.2587C14.0259 8.28319 14.0239 8.27946 14.0196 8.25418ZM16 8C16 8.5 14 15 8 15C2 15 0 8.5 0 8C0 7.5 2 1 8 1C14 1 16 7.5 16 8ZM8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z",
    fill: "#2C2D2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdventurePreview);
export default __webpack_public_path__ + "static/media/adventure-preview.816e8682d9f80132306a144ae5d8393d.svg";
export { ForwardRef as ReactComponent };